import BaseModule from './BaseModule.js';

class PixCashOuts extends BaseModule {
  async paginate({ page, per_page, term }) {
    return await this.get(`back-office/pix_cash_outs`, { params: { page, per_page, term } });
  }

  async fetch(id) {
    return await this.get(`back-office/pix_cash_outs/${id}`);
  }
}

export default PixCashOuts;
